import { Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { TodayScreen } from "./screens/TodayScreen";
import { BriefingsScreen } from "./screens/BriefingsScreen";
import { BriefingDetailScreen } from "./screens/BriefingDetailScreen";
import { CalendarScreen } from "./screens/CalendarScreen";
import { SourcesScreen } from "./screens/SourcesScreen";
import { SystemScreen } from "./screens/SystemScreen";
import { NotFoundScreen } from "./screens/NotFoundScreen";
import { appName, nav } from "./copy/sq";

const TITLES: Record<string, string> = {
  "/": nav.today,
  "/briefings": nav.briefings,
  "/calendar": nav.calendar,
  "/sources": nav.sources,
  "/system": nav.system,
};

function screenTitle(pathname: string): string {
  if (TITLES[pathname]) return TITLES[pathname];
  if (pathname.startsWith("/briefings/")) return nav.briefings;
  return appName.full;
}

export function App() {
  const location = useLocation();

  return (
    <AppShell title={screenTitle(location.pathname)}>
      <Routes>
        <Route path="/" element={<TodayScreen />} />
        <Route path="/briefings" element={<BriefingsScreen />} />
        <Route path="/briefings/:id" element={<BriefingDetailScreen />} />
        <Route path="/calendar" element={<CalendarScreen />} />
        <Route path="/sources" element={<SourcesScreen />} />
        <Route path="/system" element={<SystemScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </AppShell>
  );
}
